import { array, number, object, string } from "superstruct";

const ReviewImagesSchema = object({
    id: string(),
    url: string(),
    sizes: array(
        object({
            method: string(),
            w: number(),
            h: number(),
            url: string(),
            label: string(),
        })
    ),
});

export default ReviewImagesSchema;
